(function () {
    "use strict";

    angular.module("app").component("installationSelection", {
        templateUrl: "@/installation/installation-selection.html",
        bindings: {
            readonly: "=",
            selection: "<",
            onSelectionChanged: "=",
            getDisplayValue: "=",
            disabled: "=",
        },
        controller: PhysicalInstallationSelection
    });

    PhysicalInstallationSelection.$inject = [
        "$scope", "$attrs",
        "controllerDecorator", "infiniteScrollDataSourceFactory", "physicalInstallation",
    ];
    function PhysicalInstallationSelection(
        $scope, $attrs,
        controllerDecorator, infiniteScrollDataSourceFactory, physicalInstallation,
    ) {
        const $ctrl = this;

        controllerDecorator.Decorate($ctrl, ["dialog"]);

        $ctrl.openSearchModal = openSearchModal;
        $ctrl.removeItem = removeItem;
        $ctrl.disabled = $ctrl.disabled === "true" || ($attrs.hasOwnProperty("disabled") && $attrs.disabled === undefined);

        $ctrl.$onChanges = (changes) => {
            if (changes.selection) {
                $ctrl.activeSelection = angular.copy($ctrl.selection);
            }
        };

        function openSearchModal() {

            const scope = Object.assign($scope, prepareSearchViewModel());

            $ctrl.Dialog.Custom({
                templateUrl: "@/installation/installation-selection-search.html",
                scope,
                title: $ctrl.getTranslation("Select_Person_s"),
                size: "large",
                onEscape: true,
                closeButton: true,
                buttons: {
                    submit: {
                        label: $ctrl.getTranslation("Button_Confirm"),
                        className: "btn-primary",
                        callback: () => {
                            $ctrl.onSelectionChanged($ctrl.activeSelection);
                        },
                    },
                    cancel: {
                        label: $ctrl.getTranslation("Button_Cancel"),
                        className: "btn-default"
                    },
                },
            });

            function prepareSearchViewModel() {
                const vm = {
                    isLoadingRequests: false,
                    handleSelection,
                    isItemSelected,
                };

                vm.DataSource = infiniteScrollDataSourceFactory.CreateChild(modifyFilterAndSearch, (v) => vm.isLoadingRequests = v);

                const pageAndSort = vm.DataSource.GetPageAndSort();

                if (!pageAndSort.SortBy.length) {
                    pageAndSort.SortBy.push({ Name: "Identifier", IsReverse: false });
                }

                vm.sortType = pageAndSort.SortBy[0].Name;
                vm.sortReverse = pageAndSort.SortBy[0].IsReverse;

                return vm;

                function modifyFilterAndSearch(payload, successCallback, errorCallback, finallyCallback) {
                    physicalInstallation.SearchMine(payload, successCallback, errorCallback, finallyCallback);
                }

                function handleSelection(_event, item) {
                    const isCurrentlySelected = item.checked;

                    if (isCurrentlySelected) {
                        let itemIndex = findSelectedItemIndex(item);

                        while (itemIndex >= 0) {
                            $ctrl.activeSelection.splice(itemIndex, 1);
                            itemIndex = findSelectedItemIndex(item);
                        }

                        item.checked = false;
                    } else {
                        $ctrl.activeSelection.push(
                            {
                                publicId: item.PublicId,
                                identifier: item.Identifier,
                                zones: item.Zones.map(z => z.Description),
                            });

                        item.checked = true;
                    }
                }

                function isItemSelected(item) {
                    return findSelectedItemIndex(item) >= 0;
                }

                function findSelectedItemIndex(item) {
                    return $ctrl.activeSelection.findIndex(selectedItem => selectedItem.publicId === item.PublicId);
                }

            }
        }

        function removeItem(index, bubbleUp) {
            $ctrl.activeSelection.splice(index, 1);

            if (bubbleUp) {
                $ctrl.onSelectionChanged($ctrl.activeSelection);
            }
        }
    }
})();